import { get } from 'lodash';
import { bool, func, object, string } from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';
import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';

const CheckboxSetting = ({
  disabled,
  item,
  onChange,
  settingKey,
  title,
  tooltip = undefined, // TODO: remove this default value when adding types to this component
}) => {
  const [value, setValue] = useState(Boolean(get(item.attributes, settingKey)));

  const handleChange = (e) => {
    const newValue = e.target.checked;

    setValue(newValue);

    onChange({
      id: item.id,
      settingKey: `attributes.${settingKey}`,
      value: newValue,
    });
  };

  return (
    <Wrapper>
      <Box display="-webkit-box" mr={8}>
        {tooltip ? (
          <>
            <InputTitle
              boxProps={{ mr: 1 }}
              id={`checkboxSetting-${item.id}-${settingKey}`}
              label={title}
              tooltip={tooltip}
            />
            <Tooltip
              childrenElement={tooltip}
              initialPosition={POSITIONS['BOTTOM-RIGHT']}
            >
              <FontAwesomeIcon
                iconName="circle-info"
                iconType={CATEGORIES.SOLID}
                color="primary"
                height="16px"
              />
            </Tooltip>
          </>
        ) : (
          <InputTitle
            boxProps={{ mr: 1 }}
            id={`checkboxSetting-${item.id}-${settingKey}`}
            label={title}
            tooltip={tooltip}
          />
        )}
      </Box>
      <CheckboxInput
        disabled={disabled}
        id={`checkboxSetting-${item.id}-${settingKey}`}
        name={`checkboxSetting-${item.id}-${settingKey}`}
        onChange={handleChange}
        value={value}
        width="auto"
      />
    </Wrapper>
  );
};

export default CheckboxSetting;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;

CheckboxSetting.propTypes = {
  disabled: bool,
  item: object.isRequired,
  onChange: func.isRequired,
  settingKey: string.isRequired,
  title: string.isRequired,
};
